<div class="card card-custom">
  <form [formGroup]="form">
    <div class="card-header">
      <h3 class="m-0">{{ 'NOTE.' + data.mode + '_TITLE' | translate }}</h3>
      <button
        mat-raised-button
        type="button"
        [matTooltip]="'GLOBAL.CLOSE' | translate"
        [disabled]="submitted"
        class="btn btn-icon btn-light"
        (click)="close($event)"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
          class="svg-icon svg-icon-lg"
        ></span>
      </button>
    </div>
    <div class="card-body row m-0">
      <div class="col-4 br-light scroll" [perfectScrollbar]="{ wheelPropagation: false }">
        <div class="mb-30px">
          <div class="entities d-flex align-items-start">
            <div class="btn-group">
              <button
                type="button"
                [matTooltip]="'NOTE.ASSIGN_ENTITIES' | translate"
                [class.btn-error]="hasError('entities', 'required')"
                class="btn btn-icon-border-dashed btn-circle btn-white"
                (click)="toggleDropdownMenu($event, entitiesMenu)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Communication/Add-entity.svg"
                  class="svg-icon svg-icon-light"
                ></span>
              </button>
              <div
                #entitiesMenu
                class="dropdown-menu dropdown-menu-manual dropdown-menu-lg dropdown-menu-anim-up p-0"
              >
                <div class="bb-light px-15px">
                  <mat-form-field appearance="standard" class="w-100">
                    <mat-label>{{ 'NOTE.ENTITY_TYPE' | translate }}</mat-label>
                    <mat-select
                      #entityTypeSelect
                      (selectionChange)="handleEntityTypeChange($event.value)"
                    >
                      <mat-option *ngFor="let type of entityTypes" [value]="type">{{
                        type | enumFormat : '_'
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    style="max-height: 200px !important"
                    class="scroll w-100"
                    [perfectScrollbar]="{ wheelPropagation: false }"
                  >
                    <kt-general-autocomplete
                      #entitiesAutocomplete
                      [label]="'NOTE.ENTITIES' | translate"
                      [appearance]="'standard'"
                      [chipList]="true"
                      [dataPath]="'data'"
                      [objects]="entitiesAutocomplete.value"
                      [loadItemsFunction]="getEntitiesAutocomplete$"
                      [optionFormatter]="stringUtils.formatEntityOptionActiveInactive"
                      [chipOptionFormatter]="stringUtils.formatEntityValueActiveInactive"
                      [formatNewObjectFn]="formatNewEntity"
                      [readOnly]="!entityTypeSelect.value"
                    ></kt-general-autocomplete>
                  </div>
                </div>
                <div class="d-flex justify-content-end px-15px py-2">
                  <button
                    type="button"
                    style="min-width: 100px !important"
                    class="btn btn-sm btn-secondary"
                    (click)="handleEntitiesChange($event, entitiesMenu)"
                  >
                    {{ 'GLOBAL.SAVE' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div
              [innerHtml]="entitiesStringSub | async | safe : 'html'"
              class="flex-grow-1 ml-15px"
            ></div>
          </div>
          <div *ngIf="hasError('entities', 'required')" class="mat-form-field w-100">
            <div class="mat-form-field-wrapper">
              <div class="mat-form-field-subscript-wrapper">
                <mat-error>{{
                  'NOTE.VALIDATION.REQUIRED' | translate : { label: 'NOTE.ENTITIES' | translate }
                }}</mat-error>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center mb-15px">
          <mat-label
            class="flex-grow-1 clickable font-weight-bold"
            (click)="providedByContact.toggle()"
            >{{ 'NOTE.PROVIDED_BY_CONTACT' | translate }}</mat-label
          >
          <mat-slide-toggle
            #providedByContact
            formControlName="providedByContact"
          ></mat-slide-toggle>
        </div>
        <div [hidden]="!providedByContact.checked" class="w-100 mb-15px">
          <kt-general-autocomplete
            #contactsAutocomplete
            [label]="'NOTE.CONTACTS' | translate"
            [appearance]="'standard'"
            [chipList]="true"
            [dataPath]="'data'"
            [objects]="contactsAutocomplete.value"
            [loadItemsFunction]="getContactsAutocomplete$"
            [optionFormatter]="formatContactOption"
            [valueFormatter]="formatContactOption"
            [formatNewObjectFn]="formatNewEntity"
            [change]="handleContactsChange.bind(this)"
            [required]="providedByContact.checked"
            [readOnly]="data.fromContact || isFilteredView"
          ></kt-general-autocomplete>
          <div class="add-contact-btn">
            <button
              mat-raised-button
              type="button"
              class="btn-sm btn-light"
              (click)="AddContactHandler()"
            >
              Add Contact
            </button>
          </div>
        </div>
        <mat-form-field appearance="standard" class="w-100 mb-15px">
          <mat-label>{{ 'NOTE.DATE' | translate }}</mat-label>
          <input
            matInput
            formControlName="started"
            placeholder="ex: 2/20/2020, 2:02 PM"
            [owlDateTime]="datePicker"
            required
          />
          <owl-date-time #datePicker [hour12Timer]="true"></owl-date-time>
          <mat-error *ngIf="hasError('started', 'required')">{{
            'NOTE.VALIDATION.REQUIRED' | translate : { label: 'NOTE.DATE' | translate }
          }}</mat-error>
        </mat-form-field>
        <div class="mb-30px">
          <div
            [hidden]="showCategoryInput"
            [matTooltip]="'NOTE.TEAM_CATEGORY' | translate"
            class="label label-xl label-inline label-light-dark w-100"
            (click)="toggleCategory($event)"
          >
            {{ form.get('category').value?.name }}
          </div>
          <mat-form-field [hidden]="!showCategoryInput" appearance="standard" class="w-100">
            <mat-label>{{ 'NOTE.TEAM_CATEGORY' | translate }}</mat-label>
            <mat-select formControlName="category" required (blur)="handleCategoryChange($event)">
              <mat-option *ngFor="let category of userCategories" [value]="category">{{
                category.name
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('category', 'required')">{{
              'NOTE.VALIDATION.REQUIRED' | translate : { label: 'NOTE.TEAM_CATEGORY' | translate }
            }}</mat-error>
          </mat-form-field>
        </div>
        <div class="d-flex align-items-center mb-15px">
          <mat-label class="flex-grow-1 clickable font-weight-bold" (click)="pinned.toggle()">{{
            'NOTE.PIN_NOTE' | translate
          }}</mat-label>
          <mat-slide-toggle #pinned formControlName="pinned"></mat-slide-toggle>
        </div>
        <div *ngIf="isCreate" class="d-flex align-items-center">
          <mat-label class="flex-grow-1 clickable font-weight-bold" (click)="createTask.toggle()">{{
            'NOTE.CREATE_TASK_FROM_NOTE' | translate
          }}</mat-label>
          <mat-slide-toggle #createTask formControlName="createTask"></mat-slide-toggle>
        </div>
      </div>
      <div class="col-8">
        <div class="mb-15px">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'NOTE.SUBJECT' | translate }}</mat-label>
            <textarea
              matInput
              formControlName="subject"
              rows="2"
              [maxlength]="80"
              required
            ></textarea>
            <div class="text-right">
              {{ form.get('subject').value?.length || 0 }}
              <span class="text-muted">/80</span>
            </div>
            <mat-error *ngIf="hasError('subject', 'required')">{{
              'NOTE.VALIDATION.REQUIRED' | translate : { label: 'NOTE.SUBJECT' | translate }
            }}</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'NOTE.DESCRIPTION' | translate }}</mat-label>
            <textarea
              matInput
              formControlName="description"
              rows="17"
              [maxlength]="1000"
              required
            ></textarea>
            <div class="text-right">
              {{ form.get('description').value?.length || 0 }}
              <span class="text-muted">/1000</span>
            </div>
            <mat-error *ngIf="hasError('description', 'required')">{{
              'NOTE.VALIDATION.REQUIRED' | translate : { label: 'NOTE.DESCRIPTION' | translate }
            }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div>
        <span *ngIf="data.note?.user">
          <span class="font-weight-bolder mr-2">{{ 'NOTE.CREATED_BY' | translate }}:</span
          >{{ data.note.user }}
        </span>
      </div>
      <div>
        <button
          mat-raised-button
          type="button"
          [disabled]="submitted || !valuesChanged"
          class="btn btn-sm btn-light"
          (click)="cancel($event)"
        >
          {{ 'GLOBAL.CANCEL' | translate }}
        </button>
        <button
          mat-raised-button
          type="button"
          [disabled]="submitted || !valuesChanged"
          class="btn btn-sm btn-primary ml-15px"
          (click)="save($event)"
        >
          <ng-container *ngIf="!submitted"> {{ 'GLOBAL.SAVE' | translate }} </ng-container>
          <ng-container *ngIf="submitted">
            <span class="spinner-border spinner-border-sm"></span>
            {{ 'GLOBAL.SAVING' | translate }}
          </ng-container>
        </button>
      </div>
    </div>
  </form>
</div>
